"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentEventTypes = exports.PaymentEventType = void 0;
var PaymentEventType;
(function (PaymentEventType) {
    PaymentEventType["Producer"] = "Producer";
    PaymentEventType["NameReading"] = "Name Reading";
})(PaymentEventType = exports.PaymentEventType || (exports.PaymentEventType = {}));
exports.paymentEventTypes = Object.keys(PaymentEventType).map(key => PaymentEventType[key]);
//# sourceMappingURL=payment-event-type.js.map